import Fuse from 'fuse.js';

const supposeEmailList = ['gmail.com', 'yahoo.com', 'outlook.com', 'icloud.com', 'hotmail.com', 'live.com'];

const fuse = new Fuse(supposeEmailList);

export const matchSupposedEmail = (value: string) => {
  // If email matches one of the suppose email providers we don't need to show a message
  if (supposeEmailList.includes(value.substring(value.indexOf('@') + 1))) {
    return '';
  }

  // If email is invalid - no need to start match process
  if (!value.includes('@')) {
    return '';
  }

  const supposedValues = fuse.search(value.substring(value.indexOf('@') + 1));

  if (supposedValues.length) {
    return supposedValues[0].item;
  }

  return '';
};
